import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<Onboarding>\n  <BvSpinner />\n</Onboarding>",{ moduleName: "volta/_pods/application/loading.hbs" })